module.exports = __webpack_public_path__ + "static/media/20210109_210915_487_IMG_1710.f0bb13ea.jpg";